import React from 'react'
import { Container } from 'react-responsive-grid'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Headroom from 'react-headroom'
import '../css/markdown-styles'
import '../css/main.less'
import { rhythm } from '../utils/typography'
import { VelocityComponent, VelocityTransitionGroup } from 'velocity-react';
import { Button, Alert, Spinner } from 'elemental';
// import {FaBeer} from 'react-icons/fa/beer';
import IconClose from 'react-icons/lib/fa/close';
import '../node_modules/elemental/less/elemental.less'

// require('velocity-animate');
// require('velocity-animate/velocity.ui');
module.exports = React.createClass({
  propTypes () {
    return {
      children: React.PropTypes.any,
    }
  },
  componentWillMount(){
    this.setState({
      showSubComponent: true
    });
  },
  _button(){
    console.log("I was clicked");
    this.setState({
      showSubComponent: (this.state.showSubComponent) ? false : true
    });
  },
  render () {
    console.log("location", this.props.location.key);
    return (
      <div>
        <Headroom
          wrapperStyle={{
            marginBottom: rhythm(1),
          }}
        >
          <Container>
            <img src="/media/cropped-MyLogo3.jpeg" alt="Thomas Koefod: web applications & design"/>
          </Container>
          <Container
            className='katMenu'
            style={{
              maxWidth: 960,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >
            <Link to={prefixLink('/')}>
              Home
            </Link>
            <Link activeClassName='activeLink' to={prefixLink('/blog/')}>
              Blog
            </Link>
            <Link activeClassName='activeLink' to={prefixLink('/aboutMe/')}>
              about me
            </Link>
            <Link activeClassName='activeLink' to={prefixLink('/apps/')}>
              Apps
            </Link>
            <Link activeClassName='activeLink' to={prefixLink('/podcasts/')}>
              Podcasts
            </Link>
            <Link activeClassName='activeLink' to={prefixLink('/links/')}>
              links
            </Link>
          </Container>
        </Headroom>
        <VelocityComponent animation={this.state.showSubComponent ? "" : "slideUp"} duration={2500}>
          <Container className='callOutContainer'>
            <Container className='callOut'>
                <a href="http://www.takethis.org/">Take this - non-profit stand up for mental health</a>
                  <Button className="closeButton" size="xs" onClick={this._button} ><IconClose /></Button>
            </Container>
          </Container>
        </VelocityComponent>

        <VelocityTransitionGroup
          enter={{animation: "fadeIn", duration: 500}}
          leave={{animation: "fadeOut", duration: 500}}
          runOnMount={false}>
          <Container key={this.props.location.key} className='mainContent'>
                {this.props.children}
          </Container>
        </VelocityTransitionGroup>
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./_template.jsx